import Vue, { DirectiveOptions } from 'vue'

export const Can: DirectiveOptions = {
	inserted(el, node) {},

	bind(el, binding, vnode) {}
}

Vue.directive('can', Can)

export default Can
